/**
 * Sidebar state hook: collapse persistence + mobile drawer + Cmd/Ctrl+B shortcut.
 */

import { useState, useEffect, useCallback } from 'react';

const SIDEBAR_STORAGE_KEY = 'dwms-sidebar-collapsed';

export const useSidebar = () => {
    const [isCollapsed, setIsCollapsed] = useState(() => {
        if (typeof window !== 'undefined') {
            return localStorage.getItem(SIDEBAR_STORAGE_KEY) === 'true';
        }
        return false;
    });
    const [mobileOpen, setMobileOpen] = useState(false);

    const toggleCollapse = useCallback(() => {
        setIsCollapsed(prev => {
            const next = !prev;
            localStorage.setItem(SIDEBAR_STORAGE_KEY, String(next));
            return next;
        });
    }, []);

    const toggleMobile = useCallback(() => setMobileOpen(prev => !prev), []);
    const closeMobile = useCallback(() => setMobileOpen(false), []);

    useEffect(() => {
        const handler = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === 'b') {
                e.preventDefault();
                toggleCollapse();
            }
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [toggleCollapse]);

    return { isCollapsed, mobileOpen, toggleCollapse, toggleMobile, closeMobile, setIsCollapsed };
};

export default useSidebar;
